import Filters from "../../NotificationManagement/Listing/Filters";
import typography from "../typography";
import plusIcon from "assets/images/app/common/plus-icon.svg";

export default function Header({
    statusFilterVal = 1,
    filterUpdateHandler = () => {},
    onAddFeedbackForm = () => {},
}) {
    const statusFilterConfig = [
        { id: 1, title: typography.ALL },
        { id: 2, title: typography.ACTIVE },
        { id: 3, title: typography.INACTIVE },
    ];

    return (
        <div className="header-con-notification">
            <div className="filters-parent-con-notification">
                <Filters
                    activeTab={statusFilterVal}
                    tabClickHandler={filterUpdateHandler}
                    config={statusFilterConfig}
                    className="status-filter-con-notification"
                    label={typography.STATUS}
                    filterType="status"
                />
            </div>
            <div className="add-notification-con-notification">
                <button onClick={onAddFeedbackForm} className="add-notification-btn">
                    <img src={plusIcon} alt="plus icon" />
                    <span>{typography.ADD_FEEDBACK_FORM}</span>
                </button>
            </div>
        </div>
    );
}
